import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getBadges } from 'reducers/badge/badges';
import { formatProgressionText } from 'ChallengePage/badgeUtils';
import { withTranslation } from 'react-i18next';

const mapStateToProps = (state) => ({
    badgesAttributes: getBadges(state).attributes.data
});

const BadgesProgress = (props) => {
    const { badgeProgressValue, badgeTargetValue, showValues, t, tReady } = props;
    const progressPercent = (badgeProgressValue * 100) / badgeTargetValue;

    return (
        <div className="badge-progress">
            <div className="progress-bar">
                <div className="bar-complete-wrapper">
                    <div className="bar-complete" style={{ width: progressPercent + '%' }} />
                </div>
            </div>
            {showValues && tReady ? (
                <div className="badge-progress-label">{formatProgressionText(t, props, true)}</div>
            ) : null}
        </div>
    );
};

BadgesProgress.propTypes = {
    badgeProgressValue: PropTypes.number.isRequired,
    badgeTargetValue: PropTypes.number.isRequired,
    badgeUnitId: PropTypes.number.isRequired,
    badgeChallengeName: PropTypes.string,
    showValues: PropTypes.bool
};

export default connect(mapStateToProps)(withTranslation(['challengewidget', 'units'])(BadgesProgress));
